import React from "react";
import { answers } from "../../data/site";
import { AnswerSection } from "../answers/AnswerSection";
export function CommonAnswers() {
  return <section id="answers" aria-labelledby="answers-title" className="border-y border-line bg-ivory" data-id="element-159" data-mp="1gv5ieayd269x">
      <div className="page-container py-16 md:py-24" data-id="element-160" data-mp="1c1kjmgoy189o">
        <h2 id="answers-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-161" data-mp="175c95gloy38u">
          Answers to common questions
        </h2>
        <div className="mt-8 divide-y divide-line border-y border-line md:mt-10" data-id="element-162" data-mp="126sjp67w29bq">
          {answers.map(item => <AnswerSection key={item.id} {...item} data-id="element-163" data-mp="y68my3r897q4" />)}
        </div>
      </div>
    </section>;
}